import PropTypes from 'prop-types';

import { useTransl } from 'shared/lib/i18n';

import MessagesTemplateListItemComponent from '../../MessagesTemplate/ListItem/MessagesTemplateListItemComponent';

import { formatDate, isAdmin, loadUser } from '../../../utils';
import { getFullName } from '../../Person/utils';

const CommunityMessageListItemContainer = (props) => {
  const { t } = useTransl();
  const { thread, setCurrentChat, currentChatId } = props;

  const { id, hasUpdates, latestMessage, recipient, post } = thread;

  const { sender, text, document, createdAt } = latestMessage ?? {};
  const senderName = getFullName(sender);
  const dateFormatter = (date) => formatDate(date);
  const isCurrentChat = currentChatId === id;
  const isCurrentUserMessage = sender?.id === loadUser()?.id;

  let isHasUpdatesShown = false;
  if (
    (hasUpdates && isCurrentChat && isAdmin()) ||
    (hasUpdates && !isCurrentChat)
  ) {
    isHasUpdatesShown = true;
  }

  const previewText = text || document?.name || '';
  const messagePreview = isCurrentUserMessage
    ? `${t('metaInfo.you')}: ${previewText}`
    : `${senderName}: ${previewText}`;

  const recipientInfo = recipient?.id ? `${getFullName(recipient)} ` : '';
  const { subject } = post;

  return (
    <MessagesTemplateListItemComponent
      threadId={id}
      photo={recipient?.photo}
      recipientInfo={recipientInfo}
      createdAt={createdAt}
      messagePreview={messagePreview}
      setCurrentChat={setCurrentChat}
      isCurrentChat={isCurrentChat}
      isHasUpdatesShown={isHasUpdatesShown}
      postSubject={subject}
      dateFormatter={dateFormatter}
    />
  );
};

CommunityMessageListItemContainer.defaultProps = {
  thread: {},
  currentChatId: null,
};

CommunityMessageListItemContainer.propTypes = {
  thread: PropTypes.instanceOf(Object),
  setCurrentChat: PropTypes.func.isRequired,
  currentChatId: PropTypes.number,
};

export default CommunityMessageListItemContainer;
